import React from 'react';
import Icon from '../../../components/AppIcon';

const SectionToolbar = ({
  sectionIndex,
  totalSections,
  isSelected,
  onMoveUp,
  onMoveDown,
  onDuplicate,
  onOpenSettings,
  onDelete,
}) => {
  return (
    <div
      className={`absolute top-3 left-1/2 -translate-x-1/2 z-30 flex items-center gap-1 px-2 py-1.5 bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-700 rounded-xl shadow-xl transition-all duration-200 ${
        isSelected
          ? 'opacity-100 translate-y-0'
          : 'opacity-0 -translate-y-1 group-hover:opacity-100 group-hover:translate-y-0'
      }`}
    >
      {/* Move buttons - важны на мобилке */}
      <button
        onClick={(e) => { e.stopPropagation(); onMoveUp(); }}
        disabled={sectionIndex === 0}
        className="p-1.5 rounded-lg hover:bg-zinc-100 dark:hover:bg-zinc-800 transition-colors disabled:opacity-30 disabled:cursor-not-allowed text-zinc-700 dark:text-zinc-300"
        aria-label="Переместить вверх"
        title="Вверх"
      >
        <Icon name="ChevronUp" size={18} />
      </button>
      <button
        onClick={(e) => { e.stopPropagation(); onMoveDown(); }}
        disabled={sectionIndex === totalSections - 1}
        className="p-1.5 rounded-lg hover:bg-zinc-100 dark:hover:bg-zinc-800 transition-colors disabled:opacity-30 disabled:cursor-not-allowed text-zinc-700 dark:text-zinc-300"
        aria-label="Переместить вниз"
        title="Вниз"
      >
        <Icon name="ChevronDown" size={18} />
      </button>

      <div className="w-px h-5 bg-zinc-200 dark:bg-zinc-700 mx-1" />

      <button
        onClick={(e) => { e.stopPropagation(); onDuplicate(); }}
        className="p-1.5 rounded-lg hover:bg-zinc-100 dark:hover:bg-zinc-800 transition-colors text-zinc-600 dark:text-zinc-400"
        aria-label="Дублировать секцию"
        title="Дублировать"
      >
        <Icon name="Copy" size={16} />
      </button>
      <button
        onClick={(e) => { e.stopPropagation(); onOpenSettings(); }}
        className="p-1.5 rounded-lg hover:bg-zinc-100 dark:hover:bg-zinc-800 transition-colors text-zinc-600 dark:text-zinc-400"
        aria-label="Настройки секции"
        title="Настройки"
      >
        <Icon name="Settings" size={16} />
      </button>
      <button
        onClick={(e) => { e.stopPropagation(); onDelete(); }}
        className="p-1.5 rounded-lg hover:bg-red-100 dark:hover:bg-red-900/30 hover:text-red-600 dark:hover:text-red-400 transition-colors text-zinc-600 dark:text-zinc-400"
        aria-label="Удалить секцию"
        title="Удалить"
      >
        <Icon name="Trash2" size={16} />
      </button>

      {/* Drag handle - только на десктопе */}
      <div className="hidden md:flex items-center">
        <div className="w-px h-5 bg-zinc-200 dark:bg-zinc-700 mx-1" />
        <div className="p-1.5 cursor-grab active:cursor-grabbing text-zinc-400 dark:text-zinc-500" aria-label="Перетащить" title="Перетащить">
          <Icon name="GripVertical" size={16} />
        </div>
      </div>
    </div>
  );
};

export default SectionToolbar;
